import JoiHOC from '../JoiHOC';
import { compose, withState, withHandlers } from 'react-recompose';
import calculateUEC from './index';
import { stateHandlers } from '../common/defaultStateHandlers';

export default joiSchema => baseComponent => {
	const defaultState = {
		income: 25000,
		dismissalType: 1,
		age: 18,
	};

	const setDefaultState = {
		setDefaultState: props => () => {
			props.setState(defaultState);
			props.setErrors({});
			props.setResult(null);
		},
	};

	const onValid = props => props.setResult(calculateUEC(props.state));

	return compose(
		withState('state', 'setState', defaultState),
		withState('uec', 'setResult', null),
		JoiHOC(joiSchema, onValid),
		withHandlers(setDefaultState),
		withHandlers(stateHandlers),
	)(baseComponent);
};
